import { defineAsyncComponent } from 'vue'
export default {
  default: defineAsyncComponent(() => import("/var/www/html/bp-web-menu-v2-dev/layouts/default.vue").then(m => m.default || m))
}